import React from 'react'
import { Link } from 'gatsby'
import parser from 'html-react-parser'

export default function Contact({data}) {
    const {contactEndText, contactNumberTel, contactTitle, contactStartText, contactNumberText, contactBlocks} = data
    return (
        <div className='contact-us-wrap panel-space-70 pb-0'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12 text-center heading-head-sec'>
                        <h2 className='heading-level-2 blue-color'>{contactTitle && parser(contactTitle)}</h2>
                        <p>
                            {contactStartText && parser(contactStartText)}{' '}
                            <strong>
                                {contactNumberTel && (
                                    <Link to={`tel:${contactNumberTel}`}>
                                        {contactNumberText}
                                    </Link>
                                )}
                            </strong>{' '}
                            {contactEndText && parser(contactEndText)}
                        </p>
                    </div>
                </div>
                <div className='row'>
                    {contactBlocks.map((block, i) => (
                        <div className='col-md-6 program-col text-center' key={i}>
                            <div className='program-dt-bx d-green-bx'>
                                <div className='heading-level-4-b black-color'>
                                    {block.contactBlockTitle && parser(block.contactBlockTitle)}
                                </div>
                                <p>{block.contactBlockText && parser(block.contactBlockText)}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
